export default __webpack_public_path__ + "static/media/coin.f4e1561a.svg";